import GoalsAdapter from './base';

export default class Goal extends GoalsAdapter {
  modelNamePlural = 'goals';
}
